export const LOG_TYPES = {
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  REGULARPROCESSINFO: 4,
};

export const logTypeOptions = [{
  value: LOG_TYPES.INFO,
  label: 'Info',
}, {
  value: LOG_TYPES.WARN,
  label: 'Warn',
}, {
  value: LOG_TYPES.ERROR,
  label: 'Error',
}, {
  value: LOG_TYPES.REGULARPROCESSINFO,
  label: 'Regular Process Info',
},
];


// WEBPACK FOOTER //
// ./src/features/log/constants/logTypeConstants.js.js